// Light/dark for the sidebar, following the choice the user made in the Addy app.
//
// The app stores it in two places the sidebar can reach from inside Gmail/Outlook:
// a cookie on .addy.so (readable when the browser allows it in this iframe) and
// the user's account (settings.colorMode, returned by get-user-integrations-data).
// The cookie applies before first paint; the account value wins once it loads.

export const COLOR_MODE_COOKIE = "addy-color-mode";
const PREFERENCES = ["light", "dark", "system"];

export const isColorModePreference = (value) => PREFERENCES.includes(value);

/**
 * Inside the Addy app (Ask Addy panel) the app passes its resolved mode as
 * ?colorMode= and pushes changes over postMessage; that always wins.
 */
export const readHostMode = () => {
  try {
    const value = new URLSearchParams(window.location.search).get("colorMode");
    return value === "light" || value === "dark" ? value : null;
  } catch {
    return null;
  }
};

export const readCookiePreference = () => {
  try {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COLOR_MODE_COOKIE}=([^;]*)`));
    const value = match ? decodeURIComponent(match[1]) : null;
    return isColorModePreference(value) ? value : null;
  } catch {
    return null;
  }
};

const systemPrefersDark = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

export const resolveColorMode = (preference) =>
  preference === "dark" || (preference === "system" && systemPrefersDark()) ? "dark" : "light";

export const applyColorMode = (mode) => {
  document.documentElement.classList.toggle("dark", mode === "dark");
  document.documentElement.setAttribute("data-color-mode", mode);
};

/**
 * Spooky (an October look on dark mode) is the Addy app's choice: it passes ?spooky=1 and pushes
 * changes over postMessage. Gmail/Outlook have no way to turn it on, so they keep plain dark.
 */
export const readHostSpooky = () => {
  try {
    return new URLSearchParams(window.location.search).get("spooky") === "1";
  } catch {
    return false;
  }
};

export const applySpooky = (isSpooky) => {
  document.documentElement.classList.toggle("spooky", isSpooky);
};
